import React from 'react';
import { motion } from 'framer-motion';
import { Search, Sliders, HeartHandshake } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const steps = [{
  icon: Search,
  number: '01',
  title: 'Antes de tocarte, te evalúa.',
  description: "Analiza tu tipo de piel, tu historia, tus hábitos, tus preocupaciones específicas. Construye un mapa de lo que tu piel necesita — no de lo que funciona 'en general.'"
}, {
  icon: Sliders,
  number: '02',
  title: 'Luego diseña tu protocolo.',
  description: 'Combinando técnicas avanzadas de cuidado coreano con tecnología de última generación disponible en su spa, Kate selecciona el tratamiento exacto para tu condición. No más. No menos.'
}, {
  icon: HeartHandshake,
  number: '03',
  title: 'Y te acompaña en el proceso.',
  description: 'No te vende una sesión y desaparece. Te guía. Te educa. Te enseña a entender tu propia piel para que los resultados duren mucho más allá de la sala de tratamiento.'
}];
export function ProtocolSection() {
  const {
    t
  } = useLanguage();
  const steps = [{
    icon: Search,
    number: '01',
    title: t('protocol.s1_title'),
    description: t('protocol.s1_desc')
  }, {
    icon: Sliders,
    number: '02',
    title: t('protocol.s2_title'),
    description: t('protocol.s2_desc')
  }, {
    icon: HeartHandshake,
    number: '03',
    title: t('protocol.s3_title'),
    description: t('protocol.s3_desc')
  }];
  return <section id="protocolo" className="py-12 md:py-24 bg-brand-cream relative" data-id="element-359" data-mp="t3zy02cvpyap">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-360" data-mp="172pvvk7iw204">
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-16" data-id="element-361" data-mp="1257ldpduxeq0">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-362" data-mp="1234vr6gm9nlt">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-363" data-mp="1crhgdfahsxle">
              {t('protocol.title')}
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full mb-8" data-id="element-364" data-mp="1gvyxf6pgwwsh"></div>
            <p className="text-lg text-brand-charcoal mb-4" data-id="element-365" data-mp="1luijr87z4ald">
              {t('protocol.p1')}
            </p>
            <p className="text-xl font-medium text-brand-brown" data-id="element-366" data-mp="1qrs80kjmmg7m">
              {t('protocol.p2')}
            </p>
            <p className="text-lg text-brand-charcoal mt-4" data-id="element-367" data-mp="1vosbqot076vk">
              {t('protocol.p3')}
            </p>
          </motion.div>
        </div>

        {/* Premium framed portrait */}
        <motion.div className="group relative max-w-3xl mx-auto mb-12 md:mb-20" initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-368" data-mp="24inmcccw9pil">
          <div className="absolute inset-0 bg-brand-gold/10 translate-x-4 translate-y-4 rounded-sm transition-transform duration-700 group-hover:translate-x-6 group-hover:translate-y-6" data-id="element-369" data-mp="2ennheeon3gwq"></div>
          <div className="absolute inset-0 border border-brand-gold/40 -translate-x-4 -translate-y-4 rounded-sm transition-transform duration-700 group-hover:-translate-x-6 group-hover:-translate-y-6" data-id="element-370" data-mp="37bjbrcqqkwqc"></div>

          <div className="relative z-10 overflow-hidden rounded-sm border border-brand-gold/30 shadow-xl bg-brand-dark" data-id="element-371" data-mp="2xkexkf8vxfwk">
            <img src="https://cdn.magicpatterns.com/uploads/nnCMRw8mvAvPahteyMdWUW/EL_PROTOCOLO_PIEL_SANA,NO_PERFECTA.png" alt="Kate en su cabina de tratamiento en Tairu Aesthetics" loading="lazy" className="w-full max-h-[560px] object-cover object-top transition-transform duration-[1400ms] ease-out group-hover:scale-105" data-id="element-372" data-mp="2titl2v09j3mw" />
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/60 to-transparent" data-id="element-373" data-mp="3aqj653i510ye"></div>
            <div className="absolute bottom-5 left-5 right-5 z-20" data-id="element-374" data-mp="30u6gcgppr78x">
              <span className="block h-px w-10 bg-brand-gold mb-3 transition-all duration-700 group-hover:w-20" data-id="element-375" data-mp="30wj1t3uojzqq"></span>
              <p className="text-white font-serif text-lg md:text-2xl leading-snug" data-id="element-376" data-mp="3tj3se23c07t8">
                {t('protocol.p2')}
              </p>
            </div>
            <motion.div className="pointer-events-none absolute inset-y-0 -left-1/3 w-1/3 bg-gradient-to-r from-transparent via-white/25 to-transparent" initial={{
            x: '-50%',
            opacity: 0
          }} whileInView={{
            x: '450%',
            opacity: 1
          }} viewport={{
            once: true,
            amount: 0.25
          }} transition={{
            duration: 1.7,
            delay: 0.6,
            ease: 'easeInOut'
          }} data-id="element-377" data-mp="3frqf35w0o66n" />
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-378" data-mp="25lcjbra3zn49">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white p-8 rounded-sm shadow-sm border border-brand-gold/10 relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-379" data-mp="1hv8jlv01k7ij" data-mpi={index}>
              <div className="absolute -right-4 -top-4 text-9xl font-serif font-bold text-brand-cream opacity-50 group-hover:scale-110 transition-transform duration-500" data-id="element-380" data-mp="35e9ikwuabjcf">
                {step.number}
              </div>

              <div className="relative z-10" data-id="element-381" data-mp="3fcz2sw9nlfvu">
                <div className="w-14 h-14 bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 text-brand-gold" data-id="element-382" data-mp="3kaqsrkqqmrxe">
                  <step.icon className="w-7 h-7" data-id="element-383" data-mp="2mnrs6ywxczu8" />
                </div>
                <h3 className="text-xl font-serif text-brand-brown mb-4 font-bold" data-id="element-384" data-mp="2rm33zf6s5kf3">
                  {step.title}
                </h3>
                <p className="text-brand-charcoal leading-relaxed" data-id="element-385" data-mp="2wk4xku1u124t">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}